import { ref, watch } from 'vue';
import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { message } from 'ant-design-vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'RejectModal',
  props: {
    modalVisible: {
      type: Boolean,
      required: true
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    rejectMsg: {
      type: String,
      default: ''
    }
  },
  emits: ['update:modalVisible', 'submitReject'],
  setup(__props, {
    emit
  }) {
    const props = __props;
    const reasonValue = ref('');
    const closeModal = () => {
      reasonValue.value = '';
      emit('update:modalVisible', false);
    };
    const submitReject = () => {
      if (!reasonValue.value) return message.error('请输入驳回理由');
      emit('submitReject', reasonValue.value);
      closeModal();
    };
    watch(() => props.rejectMsg, val => {
      reasonValue.value = val;
    }, {
      immediate: true
    });
    return (_ctx, _cache) => {
      const _component_a_textarea = _resolveComponent("a-textarea");
      const _component_a_modal = _resolveComponent("a-modal");
      return _openBlock(), _createBlock(_component_a_modal, {
        title: "驳回",
        centered: "",
        open: __props.modalVisible,
        onCancel: closeModal,
        onOk: submitReject,
        "ok-text": "驳回",
        width: "435px",
        footer: __props.isEdit ? null : undefined
      }, {
        default: _withCtx(() => [_createVNode(_component_a_textarea, {
          value: reasonValue.value,
          "onUpdate:value": _cache[0] || (_cache[0] = $event => reasonValue.value = $event),
          class: "reject-textarea",
          placeholder: "请输入驳回理由",
          disabled: __props.isEdit
        }, null, 8, ["value", "disabled"])]),
        _: 1
      }, 8, ["open", "footer"]);
    };
  }
});